// Sentry must be initialized before all other imports so it can instrument
// the app and capture errors thrown during module initialization.
// eslint-disable-next-line import/order
import "./instrument";

import React, { Suspense } from "react";

import { createRoot } from "react-dom/client";
import styled from "styled-components";

import "./i18n";
import { AppConfigContextProvider } from "contexts/AppConfigContext";
import { Spinner } from "shared/atoms/Spinner";

import { App } from "./App";
import * as serviceWorker from "./serviceWorker";

if (process.env.REACT_APP_ENABLE_MOCK_SERVER) {
  if (process.env.REACT_APP_MSW_DEV_MODE) {
    import("./mocks/browser.dev").then(({ worker }) => {
      worker.start({ onUnhandledRequest: "bypass" });
    });
  } else {
    import("./mocks/browser").then(({ worker }) => {
      worker.start();
    });
  }
}

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const container = document.getElementById("root");
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);
root.render(
  <AppConfigContextProvider>
    <Suspense
      fallback={
        <Container>
          <Spinner />
        </Container>
      }
    >
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </Suspense>
  </AppConfigContextProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
